const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

async function request(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

export const api = {
  // Catalogue
  getStands: () => request('/stands'),
  getStand: (id) => request(`/stands/${id}`),
  getStandProducts: (id, available) => request(`/stands/${id}/products?available=${available || false}`),

  // Produits
  updateProduct: (id, data) => request(`/products/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  toggleProduct: (id) => request(`/products/${id}/toggle`, { method: 'PATCH' }),
  createProduct: (standId, data) => request(`/stands/${standId}/products`, { method: 'POST', body: JSON.stringify(data) }),

  // Commandes
  createOrder: (data) => request('/orders', { method: 'POST', body: JSON.stringify(data) }),
  getOrder: (id) => request(`/orders/${id}`),
  updateOrderStatus: (id, statut) => request(`/orders/${id}/status`, { method: 'PATCH', body: JSON.stringify({ statut }) }),
  notifyOrder: (id) => request(`/orders/${id}/notify`, { method: 'POST' }),
  getStandOrders: (standId, statut) => request(`/stands/${standId}/orders${statut ? `?statut=${statut}` : ''}`),

  // Clients
  getClients: () => request('/clients'),
  getStandClients: (standId) => request(`/stands/${standId}/clients`),
  getClientHistory: (clientId) => request(`/clients/${clientId}/history`),

  // Campagnes
  createCampaign: (standId, data) => request(`/stands/${standId}/campaigns`, { method: 'POST', body: JSON.stringify(data) }),

  // Analytics
  getStandAnalytics: (standId) => request(`/stands/${standId}/analytics`),

  // Aide
  requestHelp: (standId, data) => request(`/stands/${standId}/help`, { method: 'POST', body: JSON.stringify(data || {}) }),

  // Chat
  chat: (message, conversation) => request('/chat', { method: 'POST', body: JSON.stringify({ message, conversation }) }),

  // Product details
  getProductDetail: (id) => request(`/products/${id}/detail`),
  getProductStory: (id) => request(`/products/${id}/story`),
  generateProductImage: (id) => request(`/products/${id}/generate-image`, { method: 'POST' }),
};
